import React, { useEffect } from 'react';
import queryString from 'query-string';
import { WithLocalize, useLocalization } from '../../containers/I18nProvider';

import LoginForm from './LoginForm';
import RequestLoginErrorMessage from '../../components/RequestLoginErrorMessage';
import ServiceApi from '../../services/ServiceApi';

import './style.scss';

const Login = ({ location, translate }) => {
  const { changeDefaultLocale } = useLocalization();

  useEffect(() => {
    changeDefaultLocale('es');
    document.title = 'Klubb';
    document.body.className = 'yekkoclub-body';
  }, [changeDefaultLocale]);

  const api = new ServiceApi();
  const parameters = queryString.parse(location.search);

  const validateParams = () => {
    if (!parameters.client_id || !parameters.redirect_uri || !parameters.response_type) {
      return false;
    }
    return true;
  };

  return (
    <div className="yekkoclub-wrapper">
      {validateParams() ? (
        <LoginForm api={api} location={location} />
      ) : (
        <RequestLoginErrorMessage
          onlyMessage={true}
          message={translate('RequestLoginErrorMessage')}
        />
      )}
    </div>
  );
};

export default WithLocalize(Login);
